import './new-termination-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateTerminationType } from "@core/query/termination-type.query";
import { TerminationTypeFormRule, TerminationTypeFormSchema } from "@core/form/form.rule";
import { terminationTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormTerminationType from "../form-termination-type/form-termination-type";

export function NewTerminationType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTerminationType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New TerminationType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTerminationType, isLoading: isCreating } =
    useQyCreateTerminationType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TerminationTypeFormSchema>({
    defaultValues: terminationTypeFormDefault,
    resolver: zodResolver(TerminationTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TerminationTypeFormSchema) => {
    const formData = mapCreateTerminationType(form);
    addTerminationType(formData);
  };
  const handleValidateError = (err: FieldErrors<TerminationTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="TerminationType" className="termination-type">
      <HeaderContent
        title="New Termination Type"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormTerminationType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTerminationType;